import { DocumentType, MessageType } from '../../../pages/communications/models/enums/_index';
import { CustomerStatus } from '../../../models/enums/customer-status';
import { ShippingMethod } from '../../../models/enums/shipping-method';
import { DayOfWeek } from '../../../models/enums/day-of-week';
import { Division } from '../../../models/ordering/enums/division';
import { JsonProperty } from '../../../models/utilities/json-property';
import { ShipToAddressRead } from '../../../shared/models/ship-to-address-read';

export class DealerPreferences {
    public bulkBundleStruts: boolean = true;
    public assembleSprings: boolean = true;
    public steelBearingsOnSprings = false;
    public flipHorizontalAngle = false;
}

export class DealerBillingAddress {
    
    public addressLine1 : string = '';
    
    public addressLine2 : string = '';
    
    public city : string = '';
    
    public stateProvince : string = '';
    
    public postalCode : string = '';
    
    public country : string = '';
    
    public phoneNumber : string = '';
    
    public faxNumber : string = '';

    // UI Properties
    public latitude         : number = 0;
    
    public longitude        : number = 0;

}

export class DealerContactPreference {

    public documentType : DocumentType;

    public communicationMethod : MessageType;

}

export class DealerContact {

    public id : number = 0;

    public dealerId : string = '';
    
    public legacyId : number = 0;
    
    public firstName : string = '';
    
    public lastName : string = '';
    
    public emailAddress : string = '';
    
    public phoneNumber : string = '';
    
    public faxNumber : string  = '';
    
    @JsonProperty({ toClass: DealerContactPreference, designType: 'array' })
    public preferences : DealerContactPreference[] = [];

}

export class DealerMailDocument {

    public documentType : DocumentType;

}

export class DealerPaymentTerm {

    public division : Division = Division.CD;

    public paymentTermId : string = '';

}

export class DealerRead {
    
    public id : string = '';
    
    public name : string = '';
    
    public serviceCenterId : string = '';

    public currencyId : string = '';

    public isOnCreditWatch : boolean = false;

    public isTaxExempt : boolean = false;

    public isFreightTaxable : boolean = false;

    public minimumFreightCD : number|undefined = undefined;

    public maximumFreightCD : number|undefined = undefined;

    public minimumFreightRS : number|undefined = undefined;

    public maximumFreightRS : number|undefined = undefined;

    public taxRate : number = 0;

    public regionId : number|undefined = undefined;

    public rsmName: string = '';

    public isOnCreditHold: boolean = false;

    public creditHoldReason?: number | undefined = undefined;

    public defaultShippingMethod: ShippingMethod | undefined = undefined;

    public defaultShipToAddressId: number | undefined = undefined;
 
    public status : CustomerStatus = CustomerStatus.Active;

    public cutoffDay : DayOfWeek = DayOfWeek.Monday;

    public phoneNumber: string = '';

    public faxNumber: string = '';

    @JsonProperty({ toClass: DealerPreferences })
    public preferences: DealerPreferences;

    @JsonProperty({ toClass: DealerBillingAddress })
    public billingAddress : DealerBillingAddress;

    @JsonProperty({ toClass: DealerContact, designType: 'array' })
    public contacts : DealerContact[] = [];

    @JsonProperty({ toClass: DealerMailDocument, designType: 'array' })
    public mailDocuments : DealerMailDocument[] = [];

    @JsonProperty({ toClass: DealerPaymentTerm, designType: 'array' })
    public paymentTerms : DealerPaymentTerm[] = [];

    // UI Properties
    public invoiceDocumentMailed : boolean = false;

}

export class DealerDetailVM {

    public dealer : DealerRead;
    public addresses : ShipToAddressRead[] = [];

}
